// Keeps the Freibad visitor counter live. The /freibad page is served from
// Pimcore's full-page output cache, so the server-rendered number freezes
// between cache rebuilds. We poll a small JSON endpoint (as an XHR, which the
// full-page cache never stores) and patch the DOM in place. Class/threshold
// logic mirrors templates/areas/freibad-counter/view.html.twig.

const POLL_INTERVAL_MS = 30000;

// All state classes we may toggle — removed before re-applying the active set.
const BADGE_BG = ['bg-red-500/10', 'text-red-600', 'bg-orange/15', 'text-orange', 'bg-emerald-500/10', 'text-emerald-700'];
const DOT_BG = ['bg-red-500', 'bg-orange', 'bg-emerald-500'];
const BAR_BG = ['bg-red-500', 'bg-orange', 'bg-emerald-500'];

function statusFor(capacity) {
    if (capacity >= 90) {
        return { label: 'Sehr voll', badge: ['bg-red-500/10', 'text-red-600'], dot: 'bg-red-500', bar: 'bg-red-500' };
    }
    if (capacity >= 60) {
        return { label: 'Gut besucht', badge: ['bg-orange/15', 'text-orange'], dot: 'bg-orange', bar: 'bg-orange' };
    }
    return { label: 'Freie Plätze', badge: ['bg-emerald-500/10', 'text-emerald-700'], dot: 'bg-emerald-500', bar: 'bg-emerald-500' };
}

function formatTimestamp(unixSeconds) {
    const d = new Date(unixSeconds * 1000);
    const p = (n) => String(n).padStart(2, '0');
    return `Letztes Update: ${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())} Uhr`;
}

function apply(root, data) {
    const capacity = Math.max(0, Math.min(100, Number(data.capacity) || 0));
    const status = statusFor(capacity);

    const current = root.querySelector('[data-freibad-current]');
    const max = root.querySelector('[data-freibad-max]');
    const cap = root.querySelector('[data-freibad-capacity]');
    const bar = root.querySelector('[data-freibad-bar]');
    const badge = root.querySelector('[data-freibad-badge]');
    const dot = root.querySelector('[data-freibad-dot]');
    const label = root.querySelector('[data-freibad-label]');
    const updated = root.querySelector('[data-freibad-updated]');

    if (current) current.textContent = data.besucherCurrent;
    if (max) max.textContent = data.besucherMax;
    if (cap) cap.textContent = capacity;

    if (bar) {
        bar.style.width = `${capacity}%`;
        bar.classList.remove(...BAR_BG);
        bar.classList.add(status.bar);
    }
    if (badge) {
        badge.classList.remove(...BADGE_BG);
        badge.classList.add(...status.badge);
    }
    if (dot) {
        dot.classList.remove(...DOT_BG);
        dot.classList.add(status.dot);
    }
    if (label) label.textContent = status.label;
    if (updated && data.updatedAt) updated.textContent = formatTimestamp(data.updatedAt);
}

async function poll(root, endpoint) {
    try {
        const res = await fetch(endpoint, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            cache: 'no-store',
        });
        if (!res.ok) return;
        apply(root, await res.json());
    } catch (e) {
        // Network hiccup — keep the last rendered value, try again next tick.
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-freibad]');
    if (!root) return;

    const endpoint = root.dataset.freibadEndpoint;
    if (!endpoint) return;

    poll(root, endpoint); // correct a stale cached render immediately
    setInterval(() => poll(root, endpoint), POLL_INTERVAL_MS);
});
